import { useCallback, useEffect, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const OutsideClickListener = ({
  children,
  onOutsideClick
}) => {
  const outsideClickListenerRef = useRef(null);
  const handleOutsideClick = useCallback(e => {
    if (outsideClickListenerRef && outsideClickListenerRef.current && !outsideClickListenerRef.current.contains(e.target)) {
      onOutsideClick(e);
    }
  }, [onOutsideClick]);
  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [handleOutsideClick]);
  return /*#__PURE__*/_jsx("div", {
    ref: outsideClickListenerRef,
    children: children
  });
};
export default OutsideClickListener;